<template>
  <div class="d-flex flex-column mb-5">
    <div class="d-flex flex-column">
      <v-card class="d-flex mb-10 pa-5 align-center" v-for="(n, i) in selected.portfolio">
        
        <div class="d-flex flex-column flex-grow-1 mr-1">
          <div class="d-flex mb-2">
            <v-text-field
              v-model="n.name"
              label="Proj. name"
              outlined
              dense
              hide-details
              class="mr-1"
            ></v-text-field>
            <v-text-field
              v-model="n.link"
              label="Link"
              outlined
              dense
              hide-details
            ></v-text-field>
          </div>

          <v-textarea
            outlined
            hide-details
            label="Description"
            v-model="n.desc"
          ></v-textarea>
        </div>
        
        <v-btn @click="selected.portfolio = selected.portfolio.filter((n, z_i) => z_i !== i)" fab small color="error">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-card>
      <div class="d-flex">
        <v-spacer></v-spacer>
        <v-btn 
          depressed 
          @click="selected.portfolio.push({
            name: '',
            link: '',
            desc: '',
          })" 
          color="primary"
        >
          add
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      
    }
  },
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
}
</script>

<style>

</style>